import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { sentenceCase } from "change-case";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import DownloadIcon from "@mui/icons-material/Download";

import UserListToolbar from "./UserListToolbar";
import UserListHead from "./UserListHead";
import SearchNotFound from "../../../SearchNotFound";

import {
  Card,
  Table,
  Stack,
  Avatar,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Link,
  IconButton
} from "@mui/material";
import { borderLeft, padding } from "@mui/system";

const TABLE_HEAD = [
  { id: "id", label: "Title", alignRight: false },
  { id: "name", label: "Name", alignRight: false },
  { id: "date", label: "Date", alignRight: false },
  { id: "approvalFile", label: "Approval File", alignCenter: true }
];

const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_POSTDOC_3Y = "post_doc_3y";
const ROLE_POSTDOC_5Y = "post_doc_5y";
const ROLE_PHD = "PhD";

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const applySortFilter = (array, comparator, query) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return array.filter((e) => {
      const { title_en, name_en, middle_en, surname_en } = e;
      const name = `${title_en} ${name_en} ${middle_en || ""} ${surname_en}`;
      return name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    });
  }
  return stabilizedThis.map((el) => el[0]);
};

CheckedPostDocTable.propTypes = {
  checkPostDocList: PropTypes.array
};

export default function CheckedPostDocTable({ checkPostDocList }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openNamePostDoc, setOpenNamePostDoc] = useState(false);
  const [openNamePhD, setOpenNamePhD] = useState(false);

  const openName = (role) => {
    console.log(role);
    if (role === ROLE_PHD) {
      setOpenNamePhD(true);
    } else {
      setOpenNamePostDoc(true);
    }
  };

  const closeName = () => {
    setOpenNamePhD(false);
    setOpenNamePostDoc(false);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - checkPostDocList.length)
      : 0;

  const filteredUsers = applySortFilter(
    checkPostDocList,
    getComparator(order, orderBy),
    filterName
  );

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Card>
      <UserListToolbar
        filterName={filterName}
        onFilterName={handleFilterByName}
      />

      <TableContainer sx={{ minWidth: 800 }}>
        <Table>
          <UserListHead
            order={order}
            orderBy={orderBy}
            headLabel={TABLE_HEAD}
            rowCount={checkPostDocList.length}
            onRequestSort={handleRequestSort}
          />
          <TableBody>
            {filteredUsers
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const { id, name, reportFor, role, date } = row;

                return (
                  <TableRow tabIndex={-1} hover key={id}>
                    <TableCell />

                    <TableCell align="left">
                      Lorem Ipsum is simply dummy text
                    </TableCell>

                    <TableCell component="th" scope="row" padding="none">
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Avatar
                          alt={name}
                          src="/member/static/images/avatars/avatar_1.jpg"
                        />
                        <Typography>{name}</Typography>
                      </Stack>
                    </TableCell>

                    <TableCell
                      sx={{ textTransform: "capitalize" }}
                      align="left"
                    >
                      {date}
                    </TableCell>

                    <TableCell align="center">
                      <IconButton>
                        <DownloadIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
          {isUserNotFound && (
            <TableBody>
              <TableRow>
                <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                  <SearchNotFound searchQuery={filterName} />
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={checkPostDocList.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Card>
  );
}
